import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Home.css';

export default function Home() {
  const [packages, setPackages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    try {
      const res = await api.get('/packages');
      setPackages(res.data.packages);
    } catch (err) {
      console.error('Failed to load packages:', err);
    }
  };

  const createPackage = async () => {
    if (!newName.trim()) return;
    setCreating(true);
    try {
      const res = await api.post('/packages', { name: newName.trim() });
      navigate(`/pack/${res.data.package.id}`);
    } catch (err) {
      console.error('Failed to create package:', err);
    } finally {
      setCreating(false);
    }
  };

  const deletePackage = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this refi pack? This cannot be undone.')) return;
    try {
      await api.delete(`/packages/${id}`);
      setPackages(packages.filter(p => p.id !== id));
    } catch (err) {
      console.error('Failed to delete:', err);
    }
  };

  return (
    <div className="home-page">
      <div className="home-header">
        <h1 className="page-title">Your Refi Packs</h1>
        <button className="btn-primary btn-create" onClick={() => setShowModal(true)}>
          + Create New Refi Pack
        </button>
      </div>

      {packages.length === 0 ? (
        <div className="empty-state">
          <p>No refi packs yet.</p>
          <span>Click "Create New Refi Pack" to get started.</span>
        </div>
      ) : (
        <div className="pack-list">
          {packages.map(pkg => (
            <div
              key={pkg.id}
              className="pack-card"
              onClick={() => navigate(`/pack/${pkg.id}`)}
            >
              <div className="pack-info">
                <h3 className="pack-name">{pkg.name || 'Untitled Pack'}</h3>
                <div className="pack-meta">
                  <span>{pkg.address_count || 0} address{pkg.address_count !== 1 ? 'es' : ''}</span>
                  <span>Updated {new Date(pkg.updated_at).toLocaleDateString()}</span>
                </div>
              </div>
              <button
                className="btn-icon btn-delete-pack"
                onClick={(e) => deletePackage(pkg.id, e)}
                title="Delete pack"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2h3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h3a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118z"/>
                </svg>
              </button>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Create New Refi Pack</h2>
            <input
              type="text"
              placeholder="e.g. 301 Chew St Refinance"
              value={newName}
              onChange={e => setNewName(e.target.value)}
              autoFocus
              onKeyDown={e => e.key === 'Enter' && createPackage()}
            />
            <div className="modal-actions">
              <button className="btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn-primary" onClick={createPackage} disabled={creating || !newName.trim()}>
                {creating ? 'Creating...' : 'Start'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
